// actions
import { SET_SERVICE_AVAILABLE, SET_SERVICE_ACTIVE, SET_SERVICE_COUNTRY } from '../constants/types';

const initialState = {
  available: false, // Whether or not service is available for the current center of the map
  active: false, // Whether or not the service card is activated or not
  country: 'US',
};

const serviceReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SERVICE_AVAILABLE:
      return {
        ...state,
        available: action.available,
      };
    case SET_SERVICE_ACTIVE:
      return {
        ...state,
        active: action.active,
      };
    case SET_SERVICE_COUNTRY:
      return {
        ...state,
        country: action.country,
      };
    default:
      return state;
  }
};

export default serviceReducer;
